module.exports = __webpack_public_path__ + "media/images/official/special_migration_09-f5edcb0849f5d97c876323b82b366a0f.jpg";